import { render, staticRenderFns } from "./couponInfo.vue?vue&type=template&id=5374670e&scoped=true&"
import script from "./couponInfo.vue?vue&type=script&lang=js&"
export * from "./couponInfo.vue?vue&type=script&lang=js&"
import style0 from "./couponInfo.vue?vue&type=style&index=0&id=5374670e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374670e",
  null
  
)

export default component.exports